import { getRequest } from "./utils";

const $ = window.jQuery;
const modal = $("#js-popup-modal");
const csrfToken = $("meta[name='csrf-token']").attr("content");

export default function user() {

	modal.on("show.bs.modal", () => {
		$(".body").css("overflow", "hidden");
	});

	modal.on("hide.bs.modal", () => {
		$(".body").css("overflow", "");
	});

	$(document).on("click", ".js-enter-visible-password", e => {
		const element = $(e.currentTarget);
		const input = element.parents(".enter__block").find(".enter__input");
		element.toggleClass("active");

		if (input.attr("type") === "text") {
			input.attr("type", "password");
		} else {
			input.attr("type", "text");
		}
	});

	$(".checkbox__input").on("keydown", e => {
		const element = $(e.currentTarget);

		if (e.code === "Enter" || e.code === "NumpadEnter") {
			element.toggleClass("checked");
		}
	});

	$(document).on("click", ".js-login-back", () => {
		$("#recoveryModal").modal("hide");
		$("#loginModal").modal("show");
	});

	$(".js-enter-register").on("click", () => {
		$("#loginModal").modal("hide");
	});

	$(".js-enter-recovery").on("click", () => {
		$("#loginModal").modal("hide");
	});

	$(".js-enter-login").on("click", () => {
		$("#registerModal").modal("hide");
		$("#fastRegisterModal").modal("hide");
	});

	$(".js-order-revert").on("click", e => {
		const el = $(e.currentTarget);
		const id = el
			.closest(".order__item")
			.find(".js-order-revert")
			.data("id");
		getRequest("/order/cancel", { id, csrfToken }).then(
			response => {
				if (response.error === 0) {
					console.warn("успешно");
					location.reload();
				} else if (response.error === 1) {
					$(".js-order-message").text(response.message);
					$(".js-order-message")
						.parents(".order__message")
						.show();
				}
			},
			error => {
				console.error(error);
			},
		);
	});
}
